import React, {memo} from 'react';
import TimelineImages, {widths as timelineWidths} from './TimeLineImages';

const offsets = {'50': -25, '25': 0, '12': 12, '6': -6, '3': -3};

const DayHeader = (props) => {

  const {blockSize, blockDay} = props;
  const TimelineImage = TimelineImages[`${blockSize}`];
  const timelineWidth = timelineWidths[`${blockSize}`];

  return (
    <div style={{position: "relative", height: 71, minHeight: 71, maxHeight: 71, width: timelineWidth, minWidth: timelineWidth, maxWidth: timelineWidth, display: "block"}}>
        <div style={{ position: "absolute", zIndex: 50, width: "100%", height: "100%", backgroundColor: (['Sat','Sun'].indexOf(blockDay.dow)>=0?"rgba(53,196,255,0.15)":"rgba(0,0,0,0)"), marginLeft: offsets[blockSize]}}></div>
        <div style={{ position: "relative", zIndex: 100, height: 20, minHeight: 20, maxHeight: 20, width: timelineWidth, minWidth: timelineWidth, maxWidth: timelineWidth, textAlign:"center", marginLeft: 0, fontSize: blockSize===3?12:14}}>WK {blockDay.week} '{blockDay.yy}</div>
        <div style={{ position: "relative", zIndex: 100, height: 20, minHeight: 20, maxHeight: 20, width: timelineWidth, minWidth: timelineWidth, maxWidth: timelineWidth, textAlign:"center", fontWeight: "bold", marginLeft: 0}}>{blockDay.date}{blockSize > 3?` (${blockDay.dow})`:''}</div>
        <div style={{ position: "relative", zIndex: 100, paddingBottom: 5, height: 35, minHeight: 35, maxHeight: 35, width: timelineWidth, minWidth: timelineWidth, maxWidth: timelineWidth, textAlign:"center", fontWeight: "bold", marginLeft: -blockSize}}>
            <TimelineImage/>
        </div>
    </div>
  )
}
export default memo (DayHeader);